// Zentrale Inhalte für IgelGemurmel – alle Texte an einem Ort, leicht zu pflegen.

export const CONTACT = {
  phone: "0152 0200 9403",
  phoneHref: "tel:+4915202009403",
  email: "igelgemurmel@icloud.com",
  emailHref: "mailto:igelgemurmel@icloud.com",
  domain: "igelgemurmel.de",
  paypalEmail: "igelgemurmel@icloud.com",
  paypalUrl:
    "https://www.paypal.com/donate/?business=igelgemurmel%40icloud.com&item_name=Spende%20f%C3%BCr%20IgelGemurmel&currency_code=EUR",
  facebook: "https://www.facebook.com/profile.php?id=61571792610501",
  instagram: "https://www.instagram.com/igelgemurmel/",
  whatsapp: "https://wa.me/4915202009403",
  tiktok: "https://www.tiktok.com/@igelgemurmel",
};

export const PARTNER = {
  url: "https://www.rescue-center-protokoll.de/partner.html",
  logo: "/koop-logo.png",
  name: "Rescue Center Protokoll+",
};

export const IMAGES = {
  hero:
    "https://images.pexels.com/photos/134061/pexels-photo-134061.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  about:
    "https://images.pexels.com/photos/18447656/pexels-photo-18447656.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  garden:
    "https://images.pexels.com/photos/36483718/pexels-photo-36483718.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
};

export const FIRST_AID_STEPS = [
  {
    n: 1,
    title: "Mit Handschuhen sichern",
    text: "Nimm den Igel vorsichtig mit Gartenhandschuhen auf. So schützt du dich und den kleinen Stachelfreund.",
  },
  {
    n: 2,
    title: "In eine hohe Box setzen",
    text: "Eine hohe Kiste mit einem weichen Tuch und etwas Zeitung am Boden gibt dem Igel Halt und Sicherheit.",
  },
  {
    n: 3,
    title: "Warm, ruhig & dunkel",
    text: "Stell die Box an einen warmen, ruhigen und dunklen Ort. Eine lauwarme (nicht heiße) Wärmflasche tut gut.",
  },
  {
    n: 4,
    title: "Kein Futter geben",
    text: "Bitte gib erst einmal kein Futter. Ein geschwächter Igel verträgt es oft nicht – nur lauwarmes Wasser anbieten.",
  },
  {
    n: 5,
    title: "Melde dich bei mir",
    text: "Nimm schnell Kontakt mit mir auf. Gemeinsam schauen wir, was dein kleiner Findling jetzt braucht.",
  },
];

export const HELP_SIGNS = [
  "Er ist tagsüber unterwegs oder bei Kälte aktiv",
  "Er ist verletzt oder blutet",
  "Er wirkt apathisch, schwach oder sehr dünn",
  "Fliegen umschwärmen ihn oder er hat Eier/Maden",
  "Er wiegt im Herbst unter 500 g (ausgewachsen)",
  "Er liegt auf der Seite oder torkelt",
];

export const GARDEN_TIPS = [
  {
    title: "Laub & Reisig liegen lassen",
    text: "Ein Haufen aus Laub und Reisig in einer ruhigen Ecke ist ein perfektes Winterquartier.",
  },
  {
    title: "Durchgänge im Zaun",
    text: "Kleine Öffnungen von etwa 13 × 13 cm lassen Igel von Garten zu Garten wandern.",
  },
  {
    title: "Kein Gift & kein Schneckenkorn",
    text: "Verzichte auf Pestizide und Schneckenkorn – sie sind für Igel lebensgefährlich.",
  },
  {
    title: "Frisches Wasser anbieten",
    text: "Eine flache Schale mit Wasser hilft, besonders in trockenen und heißen Zeiten.",
  },
  {
    title: "Igelgerechtes Futter",
    text: "Katzennassfutter oder spezielles Igelfutter (ohne Getreide) sind eine gute Zufütterung.",
  },
  {
    title: "Vorsicht bei Gartenarbeit",
    text: "Vor dem Mähen und beim Umsetzen von Laubhaufen bitte kurz nachschauen, ob dort jemand schläft.",
  },
];

export const FEEDING = [
  {
    title: "Was Igel fressen dürfen",
    points: [
      "Katzennassfutter (hochwertig, ohne Soße)",
      "Spezielles Igeltrockenfutter",
      "Gekochtes, ungewürztes Ei oder Hähnchen",
      "Immer frisches Wasser dazu",
    ],
  },
  {
    title: "Bitte niemals füttern",
    points: [
      "Keine Milch – sie verursacht Durchfall",
      "Kein Brot und keine Essensreste",
      "Kein Obst und kein Gemüse",
      "Nichts Gewürztes oder Gesalzenes",
    ],
  },
];

export const RELEASE = [
  {
    title: "Der richtige Zeitpunkt",
    text: "Ausgewildert wird, wenn der Igel gesund, kräftig und schwer genug ist – und das Wetter mild.",
  },
  {
    title: "Am vertrauten Ort",
    text: "Am besten dort, wo er gefunden wurde. Die Umgebung kennt er bereits und findet sich schnell zurecht.",
  },
  {
    title: "Sanfter Übergang",
    text: "In den ersten Tagen stelle ich noch Futter und Wasser bereit, bis der kleine Wildling ganz allein klarkommt.",
  },
];

// Live-Zahl "Freigelassen" aus der Tierdokumentations-App "Rescue Center Protokoll+".
// Der Endpunkt muss dort einen öffentlichen JSON-Wert liefern, z. B. { "in_pflege": 21, "freigelassen": 42 }.
export const STATS_ENDPOINT =
  "https://api.rescue-center-protokoll.de/api/public/stats";
// Rückfall-Zahlen, solange der Live-Endpunkt (noch) nicht erreichbar ist. Frei anpassbar.
export const IN_CARE_FALLBACK = 21;
export const RELEASED_FALLBACK = 25;
